// bus.emit('scrollto', target, duration, 'expo.inOut')

function scrollto(){

  let defaultOptions = {
    target   : 0,
    duration : 1,// number, true (smooth), false (instant)
    ease     : "expo.inOut",
  }

  function triggerResize(){
    bus.emit('resizeContainer')
  }


  function scroll(){
    let target   = arguments[0] !== undefined ? arguments[0] : defaultOptions.target
    let duration = arguments[1] !== undefined ? arguments[1] : defaultOptions.duration
    let ease     = arguments[2] !== undefined ? arguments[2] : defaultOptions.ease


    function setOptions(){
      // clean target
      if (typeof target === 'number' && target < 0 || typeof target !== 'number') {
        target = 0
        console.warn('forcing target 0, target should be a number <= 0')
      }

      // clean duration
      if (typeof duration === 'boolean') {
        if (duration) {
          duration = defaultOptions.duration // do smooth scroll
        } else {
          duration = 0 // do instant scroll
        }
      } else if (typeof duration === 'number' && duration < 0) {
        console.warn('forcing duration 0 instead of : ' + duration)
        duration = 0
      } else if (typeof duration !== 'number') {
        console.warn('forcing duration at default, because wrong input (string or something else)')
        duration = defaultOptions.duration
      }

      // clean ease
      if (typeof ease !== 'string') {
        ease = defaultOptions.ease
      }
    }
    setOptions()


    if (duration <= 0) {
      if (window.isComplexe && scrollType === 'virtual') {
        st.current = st.eased = target
        bus.emit('virtualscroll.forcedraw')
      } else if (window.isComplexe && scrollType === 'smooth') {
        st.current = st.eased = target
        $(window).scrollTop(target)
      } else {
        $(window).scrollTop(target)
      }
    } else {
      if (window.isComplexe && scrollType === 'virtual') {
        let scrollVal = {current:st.current, target:target}
        gsap.fromTo(scrollVal, duration, {current: scrollVal.current}, {current: gsap.utils.clamp(st.min, st.max, scrollVal.target), ease:ease, onComplete:triggerResize, onUpdate:function(){
          st.current = st.eased = scrollVal.current
          bus.emit('virtualscroll.forcedraw')
        }})
      } else if (window.isComplexe && scrollType === 'smooth') {
        let scrollVal = {current:st.current, target:target}
        gsap.fromTo(scrollVal, duration, {current: scrollVal.current}, {current: gsap.utils.clamp(st.min, st.max, scrollVal.target), ease:ease, onComplete:triggerResize, onUpdate:function(){
          $(window).scrollTop(scrollVal.current)
        }})
      } else {
        let scrollVal = {current:st.current, target:target}
        gsap.fromTo(scrollVal, duration, {current: scrollVal.current}, {current: gsap.utils.clamp(st.min, st.max, scrollVal.target), ease:ease, onComplete:triggerResize, onUpdate:function(){
          $(window).scrollTop(scrollVal.current)
        }})
      }
    }

  }

  function eventOn(){
    bus.on('scrollto', scroll)
  }
  eventOn()

  /*
  if (sniffer.isSimplified || window.scrollType === 'default') {
    if (instant) {
      $(window).scrollTop(to)
    } else {
      let scrollVal = {current:st.current, from:st.current, to:gsap.utils.clamp(st.min, st.max, to)}
      function updatePos(){
        $(window).scrollTop(scrollVal.current)
      }
      gsap.fromTo(scrollVal, 1, {current: scrollVal.from}, {current: scrollVal.to, ease:"expo.inOut", onUpdate:updatePos})
    }
  } else if (window.scrollType === 'virtual') {// virtual scroll
    if (instant) {
      st.current = to
      st.eased = to
    } else {
      let scrollVal = {current:st.eased, from:st.eased, to:gsap.utils.clamp(st.min, st.max, to)}
      function updatePos(){
        st.current = st.eased = scrollVal.current
      }
      gsap.fromTo(scrollVal, 1, {current: scrollVal.from}, {current: scrollVal.to, ease:"expo.inOut", onUpdate:updatePos})
    }
  } else {// smooth scroll
    if (instant) {
      $(window).scrollTop(to)
      st.current = st.eased = to
    } else {
      $(window).scrollTop(to)
    }
  }
  */
}

export default scrollto